import { Instagram, ArrowUpRight } from "lucide-react";
import Logo from "@/components/landing/Logo";
import { SITE } from "@/lib/siteConfig";

export default function Footer() {
  return (
    <footer
      className="bg-[#0A0A0A] text-white pt-16 pb-8"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Giant logo */}
        <div className="border-b border-white/10 pb-12">
          <div className="flex items-center gap-3 mb-6">
            <Logo className="h-11 w-11" />
            <span className="font-mono-ez text-xs tracking-widest uppercase text-[#FFD600]">
              {SITE.description}
            </span>
          </div>
          <h2 className="font-display text-6xl sm:text-7xl lg:text-9xl font-black tracking-tighter leading-[0.85]">
            EZ Device<span className="text-[#FF3333]">.</span>
          </h2>
          <p className="mt-6 max-w-xl text-white/70 text-lg">
            We make it <span className="text-white font-semibold"><span className="text-[#FF3333]">e</span>a<span className="text-[#FF6B00]">z</span>y</span>. Repair, parts and trade — all under one neighborhood
            roof.
          </p>
        </div>

        {/* Columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-12 border-b border-white/10">
          <FooterCol
            title="Services"
            links={[
              { label: "Screen Replacement", href: "#services" },
              { label: "Battery Service", href: "#services" },
              { label: "Water Damage", href: "#services" },
              { label: "Board-Level Repair", href: "#services" },
              { label: "Software Diagnostics", href: "#services" },
            ]}
          />
          <FooterCol
            title="Devices"
            links={[
              { label: "Smartphones", href: "#parts" },
              { label: "Laptops", href: "#parts" },
              { label: "Tablets", href: "#parts" },
              { label: "Apple Accessories", href: "#parts" },
            ]}
          />
          <FooterCol
            title="Shop"
            links={[
              { label: "Spare Parts", href: "#parts" },
              { label: "Refurbished Devices", href: "#buysell" },
              { label: "Trade-in", href: "#buysell" },
              { label: "Visit Store", href: "#location" },
            ]}
          />
          <div>
            <div className="font-mono-ez text-xs uppercase tracking-widest text-[#FFD600] mb-4">
              Visit
            </div>
            <p className="text-sm leading-relaxed text-white/80">
              {SITE.addressLines[0]}
              <br />
              {SITE.addressLines[1]}
            </p>
            <p className="mt-4 text-sm text-white/80">
              {SITE.email}
              <br />
              {SITE.phoneDisplay}
            </p>
            <div className="flex gap-3 mt-5">
              <SocialLink
                icon={Instagram}
                href={SITE.socials.instagram}
                testId="footer-instagram"
                label="Instagram @ezdevice.id"
              />
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/50 font-mono-ez uppercase tracking-widest">
          <span>© {new Date().getFullYear()} EZ Device · All rights reserved</span>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
            <a href="#" className="hover:text-white transition-colors">Warranty</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="font-mono-ez text-xs uppercase tracking-widest text-[#FFD600] mb-4">
        {title}
      </div>
      <ul className="space-y-2">
        {links.map((l) => (
          <li key={l.label}>
            <a
              href={l.href}
              className="text-sm text-white/80 hover:text-white inline-flex items-center gap-1 group"
            >
              {l.label}
              <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

function SocialLink({ icon: Icon, href, testId, label }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="w-9 h-9 border border-white/30 flex items-center justify-center hover:bg-[#FF3333] hover:border-[#FF3333] transition-colors"
      data-testid={testId}
    >
      <Icon className="w-4 h-4" strokeWidth={1.8} />
    </a>
  );
}
